/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Studio_SubtitleInputs */

const cs_templates_studio_subtitle = /** @type {(inputs: Templates_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablony organizace pro katalog, právní dokumenty, sociální příspěvky a protokoly z prohlídky. Uložte zde; generujte z inzerátu nebo úkolu.`)
};

const en_templates_studio_subtitle = /** @type {(inputs: Templates_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization templates for catalog, legal docs, social posts, and viewing protocols. Save here; generate from a listing or viewing task.`)
};

/**
* | output |
* | --- |
* | "Organization templates for catalog, legal docs, social posts, and viewing protocols. Save here; generate from a listing or viewing task." |
*
* @param {Templates_Studio_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_studio_subtitle = /** @type {((inputs?: Templates_Studio_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Studio_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_studio_subtitle(inputs)
	return cs_templates_studio_subtitle(inputs)
});